export enum DashboardRoutesEnum {
  performance = 'performance',
  objectives = 'objectives',
  objective = 'objective',
}
